import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { PsrPriorityService } from "./psrPriorityService"
import {
  IPsrPriorityService,
  IPsrPriorityServiceItem,
} from "@/models/psr/psr.types"
import { ServicesResponse } from "@/api/backofficeRest/generated/model"

export type IPsrPriorityServiceRaw = ServicesResponse

export const PsrPriorityServiceParser: IParser<
  IPsrPriorityService,
  IPsrPriorityServiceRaw
> = {
  toDomain: (data: IPsrPriorityServiceRaw) => {
    try {
      return new PsrPriorityService({
        ...data,
        // serviceItems' type/description are free-text strings server-side; the FE narrows them to known literal unions by contract
        serviceItems: data.serviceItems as
          Array<IPsrPriorityServiceItem> | undefined,
      })
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
